import * as React from 'react';
import type { LocationDescriptor } from 'history';
import type { IUserJSON } from 'external-api-types';
import { getContactEmailForUser } from '../../../modules/general.utils';
import HybridLink from '../HybridLink/HybridLink';
import cn from '~modules/cn';
import Styles from './beta-banner.module.scss';

type Props = {
    disabled?: boolean;
    onClick?: () => void;
    bannerStyle?: 'paid' | 'trial';
    target?: string;
    className?: string;
    text?: string;
} & (
    | { to: LocationDescriptor }
    | {
          projectId: string;
          subject: string;
          user: IUserJSON;
      }
);

const BetaBanner = React.forwardRef<HTMLElement, Props>((props, ref) => {
    const { disabled, onClick, bannerStyle, target } = props;
    const className = cn(Styles.banner, props.className, {
        [Styles['banner--disabled']]: disabled,
        [Styles[`banner--${bannerStyle}`]]: bannerStyle
    });
    const text = props.text || 'Beta';
    const defaultLink =
        'to' in props ? props.to : getContactEmailForUser({ user: props.user, subject: props.subject, emailBody: `My project ID is "${props.projectId}"` });
    return (
        <HybridLink to={defaultLink} disabled={disabled} className={className} setRef={ref} onClick={onClick} target={target}>
            {text}
        </HybridLink>
    );
});

BetaBanner.displayName = 'BetaBanner';

export default BetaBanner;
